import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import Admissions from "@/pages/Admissions";
import Partners from "@/pages/Partners";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import LegalPage from "@/pages/LegalPage";
import PaymentStatus from "@/pages/PaymentStatus";
import Resources from "@/pages/Resources";
import Accountability from "@/pages/Accountability";
import ProgramDetail from "@/pages/ProgramDetail";
import ManageGift from "@/pages/ManageGift";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/admissions" element={<Admissions />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/payment/success" element={<PaymentStatus />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/accountability" element={<Accountability />} />
          <Route path="/programs/:programId" element={<ProgramDetail />} />
          <Route path="/manage/:token" element={<ManageGift />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
          <Route path="/accessibility" element={<LegalPage kind="accessibility" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
